// testimonials.js

export function testimonialsInit() {
  const ratingContainer = document.getElementById("rating-container");
  const averageContainer = document.getElementById("average-rating");

  if (!ratingContainer && !averageContainer) {
    // console.error("Weder 'rating-container' noch 'average-rating' vorhanden.");
    return;
  }

  // 📦 1. API für alle Bewertungen (für Durchschnitt)
  const API_URL_ALL = "https://app.cituro.com/api/ratings/6269629?limit=999";
  // 📦 2. API für die letzten 8 Bewertungen
  const API_URL_LIMITED = "https://app.cituro.com/api/ratings/6269629?limit=9&sort=-createdAt";

  async function loadRatings() {
    try {
      // Nur die benötigten Requests ausführen
      const promises = [];
      if (averageContainer) promises.push(fetch(API_URL_ALL));
      if (ratingContainer) promises.push(fetch(API_URL_LIMITED));

      const responses = await Promise.all(promises);
      const data = await Promise.all(responses.map(r => r.json()));

      // Ergebnisse zuordnen
      let allData = null;
      let latestData = null;

      if (averageContainer) {
        allData = data.shift();
        if (!allData?.success || !Array.isArray(allData.data)) {
          throw new Error("Fehlerhafte Antwort für alle Bewertungen");
        }
      }

      if (ratingContainer) {
        latestData = data.shift();
        if (!latestData?.success || !Array.isArray(latestData.data)) {
          throw new Error("Fehlerhafte Antwort für neueste Bewertungen");
        }
      }

      // --- Durchschnitt anzeigen ---
      if (averageContainer && allData) {
        const allRatings = allData.data;

        averageContainer.innerHTML = "";

        if (allRatings.length === 0) {
          averageContainer.innerHTML = "<p>Keine Bewertungen vorhanden.</p>";
        } else {
          const avg =
            allRatings.reduce((sum, r) => sum + (r.rating || 0), 0) / allRatings.length;

          const avgDisplay = document.createElement("div");
          avgDisplay.className = "average-display";

          const star = document.createElement("span");
          star.className = "average-star";
          star.textContent = "★";

          const avgValue = document.createElement("span");
          avgValue.className = "average-value";
          avgValue.textContent = avg.toFixed(1);

          const slash = document.createElement("span");
          slash.className = "average-slash";
          slash.textContent = " / ";

          const maxValue = document.createElement("span");
          maxValue.className = "average-max";
          maxValue.textContent = "5";

          avgDisplay.append(star, avgValue, slash, maxValue);
          averageContainer.appendChild(avgDisplay);
        }
      }

      // --- Einzelbewertungen anzeigen ---
      if (ratingContainer && latestData) {
        const latestRatings = latestData.data;
        ratingContainer.innerHTML = "";

        if (latestRatings.length === 0) {
          ratingContainer.innerHTML = "<p>Keine Bewertungen vorhanden.</p>";
        } else {
          for (const rating of latestRatings) {
            const { rating: value, customerName, comment, anonymous, createdAt } = rating;

            const ratingElement = document.createElement("div");
            ratingElement.className = "rating";

            const inner = document.createElement("div");
            inner.className = "rating-inner";

            // Sterne
            const ratingLabel = document.createElement("div");
            ratingLabel.className = "rating-stars";
            ratingLabel.textContent = "★".repeat(value || 0);
            inner.appendChild(ratingLabel);

            // Kommentar
            if (comment) {
              const commentLabel = document.createElement("div");
              commentLabel.className = "rating-comment";
              commentLabel.textContent = comment;
              inner.appendChild(commentLabel);
            }

            // Footer (Name + Datum)
            const footer = document.createElement("div");
            footer.className = "rating-footer";

            const nameLabel = document.createElement("span");
            nameLabel.className = "rating-customer";
            nameLabel.textContent = anonymous || !customerName ? "Anonym" : customerName;

            const dateLabel = document.createElement("span");
            dateLabel.className = "rating-date";
            dateLabel.textContent = formatDate(createdAt);

            footer.append(nameLabel, document.createTextNode(" | "), dateLabel);
            inner.appendChild(footer);

            ratingElement.appendChild(inner);
            ratingContainer.appendChild(ratingElement);
          }
        }
      }
    } catch (error) {
      console.error("Fehler beim Laden der Bewertungen:", error);
      if (ratingContainer) ratingContainer.innerHTML = "<p>Bewertungen konnten nicht geladen werden.</p>";
      // if (averageContainer) averageContainer.innerHTML = "<p>Durchschnitt konnte nicht geladen werden.</p>";
    }
  }

  function formatDate(dateString) {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("de-DE", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  }

  loadRatings();
}
